import { UserStatus } from 'module/api/user/types';
import DeactivatedUser from 'module/ui/assets/svgs/deactivated_user.svg';
import { Avatar } from '@rocketlane/ui';

export interface FieldEditorUserAvatarOption {
  label: string;
  value: string | number;
  imageUrl?: string;
  logoUrl?: string;
  userStatus?: UserStatus;
  extra?: {
    userStatus?: UserStatus;
  };
}

export const renderFieldEditorUserAvatar = (
  option: FieldEditorUserAvatarOption,
) => {
  const userStatus = option.userStatus ?? option.extra?.userStatus;

  return (
    <Avatar
      badgeIcon={
        option.logoUrl ? (
          <img
            alt="company-logo"
            className="h-full w-full object-cover"
            src={`${option.logoUrl}?v2`}
          />
        ) : undefined
      }
      initialsFontSize={10}
      name={option.label}
      size={20}
      src={
        userStatus === UserStatus.Inactive ? DeactivatedUser : option.imageUrl
      }
    />
  );
};
